import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "h5Bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass($data.activeTab == 1 ? 'activeTab' : ''),
    onClick: _cache[0] || (_cache[0] = $event => $options.toUrl())
  }, _toDisplayString(_ctx.$route.query.language || $props.language ? 'Home' : '首页'), 3), _createElementVNode("div", {
    class: _normalizeClass($data.activeTab == 2 ? 'activeTab' : ''),
    onClick: _cache[1] || (_cache[1] = $event => $options.toUrl(1))
  }, _toDisplayString(_ctx.$route.query.language || $props.language ? 'My' : '我的'), 3)]);
}